"use client";

import type { BlokRetailer } from "@/storyblok";

import React, { useDeferredValue, useMemo, useState } from "react";
// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
import { Map } from "./Map";
import styles from "../RetailersPage/RetailersPage.module.css";
import { Translate } from "@/components/Translate";

import { ScrollAreaBar, ScrollAreaRoot, ScrollAreaViewport } from "@/components/ui/ScrollArea";

import { matchSorter } from "match-sorter";
import { Input } from "@/components/ui/Input";
import { RetailerBlok } from "@/components/bloks/RetailerBlokBlok";

interface RetailersMapProps {
	retailers?: BlokRetailer[];
}
export const RetailersMap = ({ retailers }: RetailersMapProps) => {
	const [search, setSearch] = useState("");

	const [selected, setSelected] = useState<BlokRetailer | null>(null);
	const deferredSearch = useDeferredValue(search);

	const filteredRetailers = useMemo(() => {
		return matchSorter(retailers!, deferredSearch, {
			keys: ["name", "street", "email", "phone"],
		});
	}, [deferredSearch, retailers]);

	return (
		<div className={styles.container}>
			<ScrollAreaRoot className={styles.cardList}>
				<h2 className={styles.title}>
					<Translate>Find a retailer</Translate>
				</h2>
				<Input
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					placeholder="Search..."
					style={{ marginBottom: "var(--spacing-8)" }}
				/>
				<ScrollAreaViewport>
					{filteredRetailers.map((retailer) => (
						<button
							type="button"
							key={retailer._uid}
							onClick={() => setSelected(retailer)}
							className={styles.card}
						>
							<RetailerBlok blok={retailer} preview={false} />
						</button>
					))}
				</ScrollAreaViewport>
				<ScrollAreaBar orientation="vertical" />
			</ScrollAreaRoot>
			<div className={styles.mapContainer}>
				<Map retailers={retailers} selectedRetailer={selected} />
			</div>
		</div>
	);
};
